import React, { Fragment, useState,useContext } from "react";

import { LayoutContext,SideBarContext } from '_context/LayoutContext';
import MainSearch from 'component/MainSearch';
import SearchResult from 'component/SearchResult';

const Search = () => {
    const [ search, setSearch] = useState("");
    const [ update, setUpdate] = useState("");
    const { chgStatus, status } = useContext(LayoutContext);
    const { toggle } = useContext(SideBarContext);


    const onSearch = (value) => {
      setSearch(value);
    }

    const setHistory = (value) => {
      setUpdate(value);
    }

    return (
      <Fragment>
        <div className="wrapSearch" style={{display:status==='search'?'block':'none'}}>
          <button className="btnsBg menuLnb" onClick={() => toggle("lnb")}>메뉴</button>
          <MainSearch  onSearch={onSearch} update={update} />
          <button className="btnsBg findingWay" onClick={()=>chgStatus("rp")}>길찾기</button>
        </div>
        <div style={{display:status==='search'?'block':'none'}}>
          <SearchResult  search={search} setHistory={setHistory}/>
        </div>
      </Fragment>
    );
  };
  
  export default Search;